//here will be created all editors components and dialog for edit
import {
    DialogTitle, DialogContent, DialogActions,
    Button, Grid, TextField, Switch,
    Typography, Stack, FormGroup, Tooltip,
    Box, Chip, ListItem, Paper, IconButton,
    FormControl, OutlinedInput, InputAdornment, InputLabel, Select, MenuItem,
} from '@mui/material';
import * as React from "react";
import {useTranslation} from "react-i18next";
import makeStyles from "@mui/styles/makeStyles";
import * as _ from "lodash";
import moment from "moment";
import {Autocomplete} from "@mui/lab";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AddBoxIcon from '@mui/icons-material/AddBox';
import CancelIcon from '@mui/icons-material/Cancel';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DatePicker from "@mui/lab/DatePicker";
import {useDispatch, useSelector} from 'react-redux';
import {user} from "../../../store/reducers/user";
import {setSnackbar} from '../../../store/reducers/globals';
import {prepareDictArrayNames, getStringValue} from './admin_dictionaries_helpers';
import {useWebSocket} from '../../../context/WebSocketProvider';
import {useEffect} from 'react';

const useStyles = makeStyles((theme) => ({
    dictRepresentationMissing: {
        color: "#FF6868",
        fontSize: "12px",
        cursor: "help",
        "& svg":{
            fontSize: "18px",
            marginLeft: "4px",
        }
    },
    listHeader: {
        backgroundColor: theme.palette.background.listHeader,
        backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))",
        paddingLeft: "8px",
        fontSize: "smaller",
        paddingTop: "4px",
        position: "relative",
        top: "5px",
        borderRadius: "4px"
    },
    tagsList: {
        "& li": {
            paddingLeft: "4px",
            paddingRight: "4px",
            "&:first-of-type": {
                paddingLeft: "8px"
            },
            "& button": {
                padding: "0px"
            }
        }
    },
    newTagItem: {
        borderRadius: "20px",
        paddingRight: "8px",
        "& input": {
            padding: "7px 0px 7px 16px"
        }
    },
    tagListObjectAdd: {
        flexDirection: "row",
        alignItems: "center"
    },
    tagListButton: {
        display: "inline-flex"
    },
    tagListObjectInput: {
        marginBottom: "5px",
        marginRight: "5px"
    },
    inputColorPickerContainer: {
        marginLeft: "5px",
        marginRight: "-8px",
        "& fieldset": {
            borderRadius: "4px",
            borderWidth: "1px",
            borderColor: theme.palette.fieldsetBorderColor.primary,
            paddingBottom: "15px",
            "&:hover":{
                borderColor: theme.palette.fieldsetBorderColor.hover,
            }
        }
    },
    inputColorPickerLegend: {
        transform: "matrix(0.75, 0, 0, 0.75, -1, -2)",
        opacity: "0.75"
    },
    inputColorPickerText: {
        fontSize: "1rem",
        width: "calc(100% - 80px)",
        background: "transparent",
        border: "0px",
        color: theme.palette.text.primary,
        outline: "0px"
    },
    inputColorPickerColor: {
        width: "50px",
        border: "0px",
        outline: "0px",
        float: "right",
        height: "24px",
        cursor: "pointer"
    }
}));

export function DictionariesAdminEditForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const {sendMessage, manageSubscription, message} = useWebSocket();

    const [editObject, setEditObject] = React.useState({});
    const [configFormFields, setConfigFormFields] = React.useState(null);
    const [additionalDicts, setAdditionalDicts] = React.useState({});
    const [addingNewStringChip, setAddingNewStringChip] = React.useState("");
    const [addingNewNumberChip, setAddingNewNumberChip] = React.useState("");
    const [addingNewObjectChip, setAddingNewObjectChip] = React.useState({});
    const [addingNewStringChipField, setAddingNewStringChipField] = React.useState(null);
    const userObject = useSelector(user);

    const defDateFormat = "YYYY-MM-DD HH:mm:ss";
    const [transformHelperFields, setTransformHelperFields] =  React.useState(null);
    const [availableModules] = React.useState( () => {
        let am = [];
        _.forEach(props.activeModules, acm => {
            if(acm.enabled) am.push(acm.id);
        })
        return am;
    })

    useEffect(() => {
        manageSubscription([props.listeningChanel]);
    }, []);

    React.useEffect(()=>{
        let dictionariesConfigFields = {};
        let tmpEditObject = {};
        let transformHelper = {
            numbers: [],
            dates: [],
            arrays: [],
            divided: [],
            dividedFields: []
        }
        if(props.config) {
            //build config
            let configFormsTmp = [];
            props.config.fields.map((field) => {
                //console.log("field", field);
                if(!field.hasOwnProperty("moduleAccess") || (field.hasOwnProperty("moduleAccess") && availableModules.indexOf(field.moduleAccess) > -1)) {
                    configFormsTmp.push(field);
                    if (field.type == 'dictionary' || field.type == "search" || field.type == "dictionaryList" || field.type == "searchList" || field.type == "dividedSearchList") {
                        dictionariesConfigFields[field.dict] = {
                            dictDisplayField: field.dictDisplayField ? field.dictDisplayField : "_id",
                            dictDisplayFieldCode: field.dictDisplayFieldCode ? field.dictDisplayFieldCode : null,
                            idField: field.idField ? field.idField : "_id"
                        }
                    }
                    ///build tmp object with every fields!!!
                    // field.id
                    switch (field.type) {
                        case "number":
                            transformHelper.numbers.push(field.id.replace(".", "___"));
                            tmpEditObject[field.id.replace(".", "___") + "_number"] = "";
                            break;
                        case "date": {
                            transformHelper.dates.push(field.id.replace(".", "___"));
                            tmpEditObject[field.id.replace(".", "___") + "_date"] = null;
                            break;
                        }
                        case "stringList":
                        case "numberList":
                        case "searchList":
                        case "dictionaryList":
                            transformHelper.arrays.push(field.id.replace(".", "___"));
                            tmpEditObject[field.id.replace(".", "___") + "_array"] = [];
                            break;
                        case "dividedSearchList":
                            transformHelper.divided.push(field.id.replace(".", "___"));
                            transformHelper.dividedFields.push(field);
                            tmpEditObject[field.id.replace(".", "___") + "_array_" + field.divided.name] = [];
                            break;
                        default:
                            _.set(tmpEditObject, field.id, null);
                    }
                }
            });
            setConfigFormFields(configFormsTmp);
        }
        if(props.additionalDicts && props.config) {
            //need to prepare dicts
            let tmpAdditionalDicts = {};
            Object.keys(props.additionalDicts).forEach((inputDictKey) => {
                if(dictionariesConfigFields.hasOwnProperty(inputDictKey)) {
                    tmpAdditionalDicts[inputDictKey] = [];
                    _.orderBy(props.additionalDicts[inputDictKey], [dictionariesConfigFields[inputDictKey]['dictDisplayField']], ['asc']).forEach((dictItem) => {
                        let label = dictItem[dictionariesConfigFields[inputDictKey]['dictDisplayField']];
                        if (dictionariesConfigFields[inputDictKey]['dictDisplayFieldCode']) {
                            label += ` (${getStringValue(dictItem, dictionariesConfigFields[inputDictKey]['dictDisplayFieldCode'], ", ")})`
                            //
                            // const codes = dictionariesConfigFields[inputDictKey]['dictDisplayFieldCode'];
                            // if(Array.isArray(codes)){
                            //     let cLabels = [];
                            //     _.forEach(codes, codeField => {
                            //         cLabels.push(dictItem[codeField]);
                            //     })
                            //     label += ` (${cLabels.join(", ")})`
                            // } else {
                            //     if(typeof codes == "string"){
                            //         label += ` (${dictItem[codes]})`
                            //     }
                            // }
                        }
                        tmpAdditionalDicts[inputDictKey].push({label: label, item: dictItem});
                    })
                }
            })
            setAdditionalDicts(tmpAdditionalDicts);
            if(props.record) {
                tmpEditObject = _.cloneDeep({...tmpEditObject, ...props.record});
                const dictFields = _.filter(props.config.fields, (fieldConfig) => {
                    return (fieldConfig.dict != null &&  ["search","dictionary"].indexOf(fieldConfig.type) >= 0);
                });
                _.forEach(dictFields, (dictFieldConfig) => {
                    //for search
                    const additionalDictFieldItem = "" + dictFieldConfig.id + "_dict_item";
                    const elementValue = _.get(tmpEditObject, dictFieldConfig.id);
                    if(elementValue != null && elementValue != "") {
                        const idField = dictFieldConfig.idField ? dictFieldConfig.idField : "_id";
                        let dictVal; //?? is it objectID or string ?
                        switch(dictFieldConfig.type) {
                            case "search": {
                                dictVal = _.find(tmpAdditionalDicts[dictFieldConfig.dict], (element) => {
                                    if(typeof elementValue == "object" && elementValue["$oid"]){
                                        if(typeof element.item[idField] == "object" && elementValue["$oid"]){
                                            return (element.item[idField] == elementValue["$oid"]);
                                        } else {
                                            return (element.item[idField]["$oid"] == elementValue["$oid"]);
                                        }
                                    }
                                    return (element.item[idField] == elementValue);
                                });
                            }
                            case "dictionary": {
                                if(elementValue.hasOwnProperty("$oid")){
                                    dictVal = _.find(tmpAdditionalDicts[dictFieldConfig.dict], (element) => {
                                        return (element.item[idField]["$oid"] == elementValue["$oid"]);
                                    });
                                }
                            }
                        }
                        if (dictVal) {
                            tmpEditObject[additionalDictFieldItem] = dictVal;
                        } else {
                            //try to search
                            if(props.additionalDictsAll && props.additionalDictsAll.hasOwnProperty(dictFieldConfig.dict)){
                                let additionalDictVal = _.find(props.additionalDictsAll[dictFieldConfig.dict],(element) => {
                                    if(typeof elementValue == "object" && elementValue["$oid"]){
                                        if(typeof element[idField] == "object" && elementValue["$oid"]){
                                            return (element[idField] == elementValue["$oid"]);
                                        } else {
                                            return (element[idField]["$oid"] == elementValue["$oid"]);
                                        }
                                    }
                                    return (element[idField] == elementValue);
                                });
                                if (additionalDictVal) {
                                    tmpEditObject[additionalDictFieldItem] = dictVal;
                                }
                                else {
                                    tmpEditObject[additionalDictFieldItem] = JSON.stringify(elementValue);
                                }
                            } else {
                                tmpEditObject[additionalDictFieldItem] = JSON.stringify(elementValue);
                            }
                        }
                    } else {
                        tmpEditObject[additionalDictFieldItem] = null;
                        //no value element, search in complete dictionary
                    }
                });
                _.forEach(transformHelper.numbers, fieldId => {
                    if(tmpEditObject[fieldId]) {
                        try {
                            tmpEditObject[fieldId+"_number"] =  Number(tmpEditObject[fieldId].$numberInt);
                        } catch (ex) {
                            console.error(ex);
                            tmpEditObject[fieldId+"_number"] = tmpEditObject[fieldId];
                        }
                    }
                });
                _.forEach(transformHelper.dates, fieldId => {
                    if(tmpEditObject[fieldId]) {
                        try {
                            let dateLong = Number(tmpEditObject[fieldId].$date.$numberLong);
                            tmpEditObject[fieldId + "_date"] = moment.utc(dateLong);
                        } catch (ex) {
                            console.error(ex);
                            tmpEditObject[fieldId + "_date"] = tmpEditObject[fieldId];
                        }
                    }
                });
                _.forEach(transformHelper.arrays, fieldId => {
                    ///what to do ? //// tutaj dodac brakujace itemy ze słowników jesli nie ma !!!! lub lista sie nie zgadza!
                    let arrayField = fieldId + "_array";
                    if(tmpEditObject[fieldId] && Array.isArray(tmpEditObject[fieldId]) && tmpEditObject[fieldId].length != tmpEditObject[arrayField].length){
                        //console.log("inconsistent length between " + fieldId + " and " + arrayField);
                        let fieldCfg = _.find(props.config.fields, (cfg) => cfg.id == fieldId);
                        if(fieldCfg){
                            tmpEditObject[arrayField] = prepareDictArrayNames(tmpEditObject[fieldId], fieldCfg, props.additionalDictsAll[fieldCfg.dict])
                        } else {
                            console.error("Configuration for field " + fieldId + " not found!!!");
                        }
                    }
                });
                _.forEach(transformHelper.dividedFields, fieldConfig => {
                    ///what to do ? //// tutaj dodac brakujace itemy ze słowników jesli nie ma !!!! lub lista sie nie zgadza!
                    let arrayField = fieldConfig.id + "_array_" + fieldConfig.divided.name;
                    let arrayLabelsField = fieldConfig.id + "_arrayLabels_" + fieldConfig.divided.name;
                    if(tmpEditObject[fieldConfig.divided.baseFieldId] && Array.isArray(tmpEditObject[fieldConfig.divided.baseFieldId]) && tmpEditObject[fieldConfig.divided.baseFieldId].length != tmpEditObject[arrayField].length){
                        tmpEditObject[arrayField] = [];
                        _.forEach(tmpEditObject[fieldConfig.divided.baseFieldId], (baseFieldData) => {
                            let baseFieldDataStr = baseFieldData.hasOwnProperty("$oid") ? baseFieldData["$oid"] : baseFieldData;
                            if(_.find(props.additionalDictsAll[fieldConfig.dict], (dictItem) => {
                                let dictItemId = dictItem[fieldConfig.idField].hasOwnProperty("$oid") ? dictItem[fieldConfig.idField]["$oid"] : dictItem[fieldConfig.idField];
                                return dictItemId == baseFieldDataStr})){
                                tmpEditObject[arrayField].push(baseFieldData);
                            }
                        })
                        tmpEditObject[arrayLabelsField] = prepareDictArrayNames(tmpEditObject[arrayField], fieldConfig, props.additionalDictsAll[fieldConfig.dict])
                    }
                });
                setTransformHelperFields(transformHelper);
                setEditObject(tmpEditObject);
                sendMessageUserEditingTableRecord("openToEdit");
            }
        }
    }, [props.record, props.config, props.additionalDicts, props.additionalDictsAll]);

    React.useEffect(()=> {
        if(message) {
            try {
                const msg = message;
                if (msg.data && msg.data.viewed && msg.data.viewed == props.config.name) {
                    sendMessageUserEditingTableRecord("editing");
                }
            } catch (ex) {
                console.log(ex);
            }
        }
    }, [message])

    const sendMessageUserEditingTableRecord = (action) => {
        const data = {
            record: props.record,
            table: props.config.name,
            action: action, ///openToEdit | editing | closeEdit (noChanges) | save (withChanges) | delete ////
        }
        sendMessage(data, [props.webSocketChanel])
    }
    const fieldconfig = (fieldId) => {
        let ffid = fieldId;
        if(ffid.endsWith("_number")) { ffid = fieldId.substring(0, (ffid.length - "_number".length)); }
        if(ffid.endsWith("_date")) { ffid = fieldId.substring(0, (ffid.length - "_date".length )); }
        if(ffid.endsWith("_dict_item")) { ffid = fieldId.substring(0, (ffid.length - "_dict_item".length )); }
        if(ffid.endsWith("_dict__id")) { ffid = fieldId.substring(0, (ffid.length - "_dict__id".length )); }
        if(ffid.endsWith("_array")) { ffid = fieldId.substring(0, (ffid.length - "_array".length )); }
        if(ffid.endsWith("_itemArrays")) { ffid = fieldId.substring(0, (ffid.length - "_itemArrays".length )); }
        if(ffid.match("_array_")) { ffid = fieldId.substring(0, ffid.indexOf("_array_")); }
        if(ffid.match("_arrayLabels_")) { ffid = fieldId.substring(0, ffid.indexOf("_arrayLabels_")); }

        const fieldConfig = _.find(configFormFields, (field) => {
            return field.id === ffid;
        });
        return fieldConfig;
    }
    const isRequired = (fieldId) => {
        let fieldConfig = fieldconfig(fieldId);
        return fieldConfig && fieldConfig.required;
    }
    const getConfigDictionaryIdFieldName = (fieldId) => {
        const fieldConfig = _.find(configFormFields, (field) => {
            return field.id == fieldId;
        });
        return fieldConfig && fieldConfig.idField ? fieldConfig.idField : "_id";
    }

    const handleCancel = (event) => {
        sendMessageUserEditingTableRecord("closeEdit");
        setEditObject({});
        props.handleCancel(event);
    }

    const handleSave = (event) => {
        let tmp = _.cloneDeep(editObject);
        let stopRequired = false;
        Object.keys(editObject).forEach((key) => {
            if(isRequired(key) && !tmp[key]) {
                let fieldConfig = fieldconfig(key);
                dispatch(setSnackbar({type: "error", message: `${fieldConfig.display} is required!`}));
                stopRequired = true;
            }
            if(!stopRequired) {
                if (_.endsWith(key, "_dict_item")) {
                    delete tmp[key];
                }
                // if(_.endsWith(key, "_dict__id")){
                //     delete tmp[key];
                // }
                if (_.endsWith(key, "_array") && _.indexOf(transformHelperFields.arrays, key.slice(0, -6)) > -1) {
                    delete tmp[key];
                }
                // if (_.endsWith(key, "_itemArrays") && _.indexOf(transformHelperFields.arrays, key.slice(0, -6)) > -1) {
                //     delete tmp[key];
                // }
                if (_.endsWith(key, "_number") && _.indexOf(transformHelperFields.numbers, key.slice(0, -7)) > -1) {
                    if (tmp[key]) {
                        let tmpKey = key.substr(0, key.length - 7);
                        tmp[tmpKey] = {$numberInt: `${tmp[key]}`};
                    }
                    delete tmp[key];
                }
                if (_.endsWith(key, "_date") && _.indexOf(transformHelperFields.dates, key.slice(0, -5)) > -1) {
                    if (tmp[key] && moment.isMoment(tmp[key])) {
                        let tmpKey = key.substr(0, key.length - 5);
                        tmp[tmpKey] = {$date: {$numberLong: `${tmp[key].valueOf()}`}}
                    }
                    delete tmp[key];
                }
            }
        });
        if(!stopRequired) {
            let dividedFieldsGroups = _.groupBy(transformHelperFields.dividedFields, (dFieldConfig) => { return dFieldConfig.divided.baseFieldId });
            Object.keys(dividedFieldsGroups).forEach((dividedBaseField) => {
                tmp[dividedBaseField] = [];
                dividedFieldsGroups[dividedBaseField].forEach((fieldConfig) => {
                    let tmpArray = tmp[fieldConfig.id.replace(".","___")+"_array_" + fieldConfig.divided.name];
                    if(tmpArray && Array.isArray(tmpArray)){
                        tmpArray.forEach(pickedItems => {
                            tmp[dividedBaseField].push(_.cloneDeep(pickedItems));
                        })
                    }
                    delete tmp[fieldConfig.id.replace(".","___")+"_array_" + fieldConfig.divided.name];
                    delete tmp[fieldConfig.id.replace(".","___")+"_arrayLabels_" + fieldConfig.divided.name];
                    delete tmp[fieldConfig.id.replace(".","___")+"_itemArrays"];
                })
            })
            props.save(tmp);
        }
    }

    const addingNewChip = (fieldId, configStructure) => {
        setAddingNewStringChip("");
        setAddingNewNumberChip("");
        if(configStructure) {
            let chipObjectStructure = {valid: false};
            Object.keys(configStructure).forEach(fieldName => {
                chipObjectStructure[fieldName] = configStructure[fieldName] == "text" ? "" : null;
            })
            setAddingNewObjectChip(chipObjectStructure);
        }
        setAddingNewStringChipField(fieldId);
    }

    const addingNewObjectChipValidation = (inputObject) => {
        inputObject['valid'] = true;
        Object.keys(inputObject).forEach((objKey) => {
            if(objKey != "valid"){
                inputObject['valid'] = inputObject['valid'] && inputObject[objKey] != null;
               if(inputObject['valid'] && typeof inputObject[objKey] == "string"){
                   inputObject['valid'] = inputObject['valid'] && inputObject[objKey].length > 0;
               }
            }
        });
        setAddingNewObjectChip(inputObject);
    }

    const cancelAddingNewChip = (event) => {
        setAddingNewStringChipField(null);
        setAddingNewObjectChip({});
    }

    const saveAddingNewTextChip = (event) => {
        let tmpObj = _.cloneDeep(editObject);
        let itemArrGet = _.get(tmpObj, addingNewStringChipField);
        if(itemArrGet && Array.isArray(itemArrGet)){
            if(itemArrGet.indexOf(addingNewStringChip) < 0) {
                itemArrGet.push(addingNewStringChip);
            } else {
                //item exists
            }
        } else {
            itemArrGet = [addingNewStringChip];
        }
        _.set(tmpObj, addingNewStringChipField, itemArrGet);
        setEditObject(tmpObj);
        setAddingNewStringChipField(null);
    }

    const saveAddingNewNumberChip = (event) => {
        let tmpObj = _.cloneDeep(editObject);
        let itemArrGet = _.get(tmpObj, addingNewStringChipField);
        if(itemArrGet && Array.isArray(itemArrGet)){
            _.remove(itemArrGet, item => {
                return JSON.stringify(item) == JSON.stringify({$numberInt:addingNewNumberChip});
            });
            itemArrGet.push({$numberInt:addingNewNumberChip});
        } else {
            itemArrGet = [{$numberInt:addingNewNumberChip}];
        }
        _.set(tmpObj, addingNewStringChipField, itemArrGet);
        setEditObject(tmpObj);
        setAddingNewStringChipField(null);
    }

    const saveAddingNewObjectChip = (subFieldsConfig) => {
        let tmpObj = _.cloneDeep(editObject);
        let itemArrGet = _.get(tmpObj, addingNewStringChipField);
        let chipObj = {}
        Object.keys(subFieldsConfig).forEach(subFieldKey => {
            if (addingNewObjectChip.hasOwnProperty(subFieldKey)) {
                if (subFieldsConfig[subFieldKey] == "text"){
                    chipObj[subFieldKey] = addingNewObjectChip[subFieldKey];
                } else {
                    chipObj[subFieldKey] = {};
                    chipObj[subFieldKey][subFieldsConfig[subFieldKey]] = addingNewObjectChip[subFieldKey].toString();
                }
            }
        })
        if(itemArrGet && Array.isArray(itemArrGet)) {
            itemArrGet.push(chipObj);
        } else {
            itemArrGet = [chipObj];
        }
        _.set(tmpObj, addingNewStringChipField, itemArrGet);
        setEditObject(tmpObj);
        setAddingNewStringChipField(null);
    }

    const setDictField = (selected, reason, legacyFieldId, dictFieldId) => {
        let dictItemKey = legacyFieldId + "_dict_item";
        let dictItemId = legacyFieldId + "_dict__id";
        let tmpEO = {...editObject};
        ////do something;
        switch (reason) {
            case "clear": {
                tmpEO[legacyFieldId] = null
                tmpEO[dictItemKey] = null;
                tmpEO[dictItemId] = null;
                break;
            }
            case "selectOption": {
                tmpEO[legacyFieldId] = selected.item[getConfigDictionaryIdFieldName(legacyFieldId)]
                tmpEO[dictItemKey] = selected;
                let selectedId = selected.item["_id"];
                if(typeof selectedId == 'object'){
                    //tmpEO[dictItemId] = selectedId["$oid"]; we have mixed ID sometimes, like there is specialties with id String and autogenerate ObjectId
                    tmpEO[dictItemId] = selectedId;
                } else {
                    tmpEO[dictItemId] = selectedId;
                }
            }
        }
        setEditObject(tmpEO);
    }

    const setDictFieldAddToArray = (selected, reason, configField, details) => {
        const dictItemArray = configField.id + "_itemArrays";
        let tmpEO = {...editObject};
        if(configField.hasOwnProperty("divided")){
            if(!tmpEO.hasOwnProperty(configField.id + "_array_" + configField.divided.name) || tmpEO[configField.id + "_array_" + configField.divided.name] == null) tmpEO[configField.id + "_array_" + configField.divided.name] = [];
            if(!tmpEO.hasOwnProperty(configField.id + "_arrayLabels_" + configField.divided.name) || tmpEO[configField.id + "_arrayLabels_" + configField.divided.name] == null)tmpEO[configField.id + "_arrayLabels_" + configField.divided.name] = [];
        } else {
            if(!tmpEO.hasOwnProperty(configField.id) || tmpEO[configField.id] == null){
                tmpEO[configField.id] = [];
            }
            if(!tmpEO.hasOwnProperty(configField.id + "_array") || tmpEO[configField.id + "_array"] == null){
                tmpEO[configField.id + "_array"] = [];
            }
        }
        switch (reason) {
            case "clear": {
                tmpEO[configField.id].splice(0,tmpEO[configField.id].length);
                tmpEO[configField.id + "_array"].splice(0, tmpEO[configField.id+"_array"].length);
                if(configField.hasOwnProperty("divided")) {
                    tmpEO[configField.id+"_array_"+configField.divided.name].splice(0, tmpEO[configField.id+"_array_"+configField.divided.name].length);
                    tmpEO[configField.id+"_arrayLabels_"+configField.divided.name].splice(0, tmpEO[configField.id+"_arrayLabels_"+configField.divided.name].length);
                }
                if(tmpEO.hasOwnProperty(dictItemArray) && Array.isArray(tmpEO[dictItemArray])) {
                    tmpEO[dictItemArray].splice(0, tmpEO[dictItemArray].length);
                } else {
                    tmpEO[dictItemArray] = [];
                }
                break;
            }
            case "selectOption": {
                let selectedId;
                let getSelectedDisplayAndCode = (selectedOptionArr, dictDisplayField, dictDisplayFieldCode) => {
                    let retSelectedLabel;
                    let tmpSelectedDisplayCode = [];
                    retSelectedLabel = dictDisplayField ? selectedOptionArr[ selectedOptionArr.length - 1].item[dictDisplayField] : selectedOptionArr[selectedOptionArr.length - 1].label;
                    if (dictDisplayFieldCode) {
                        if (Array.isArray(dictDisplayFieldCode)) {
                            let cLabels = [];
                            _.forEach(configField.dictDisplayFieldCode, codeField => {
                                let cValue = selectedOptionArr[selectedOptionArr.length - 1].item[codeField];
                                if (typeof cValue == "string") {
                                    cLabels.push(cValue);
                                } else {
                                    cLabels.push(JSON.stringify(cValue));
                                }
                            });
                            tmpSelectedDisplayCode.push(...cLabels);
                        } else if (typeof dictDisplayFieldCode == "string") {
                            tmpSelectedDisplayCode.push(selectedOptionArr[selectedOptionArr.length - 1].item[dictDisplayFieldCode]);
                        }
                    }
                    if(tmpSelectedDisplayCode.length > 0){
                        retSelectedLabel += " (" + tmpSelectedDisplayCode.join(", ") + ")";
                    }
                    return retSelectedLabel;
                }
                let getSelectAllSelected = (dictName, idField, dictDisplayField, dictDisplayFieldCode) => {
                    let allSelectedArray_ids = [];
                    let allSelectedArray_items = [];
                    let allSelectedArray_arrayDisplays = [];
                    additionalDicts[dictName].forEach(dictItem => {
                        let dictItemId = idField ? dictItem.item[idField] : dictItem.item["_id"];
                        if(dictItemId != 'selectAll'){
                            allSelectedArray_ids.push(dictItemId);
                            allSelectedArray_items.push(dictItem);
                            allSelectedArray_arrayDisplays.push(getSelectedDisplayAndCode([dictItem],dictDisplayField, dictDisplayFieldCode || null));
                        }
                    });
                    return [allSelectedArray_ids, allSelectedArray_items, allSelectedArray_arrayDisplays];
                }

                let selectedLabel = "";
                let selectedIdStd;

                if(Array.isArray(selected)){
                    selectedId = configField.hasOwnProperty("idField") ? selected[selected.length-1].item[configField.idField] : selected[selected.length-1].item["_id"];
                    selectedLabel = getSelectedDisplayAndCode(selected, configField.dictDisplayField || null, configField.dictDisplayFieldCode || null);
                    if (tmpEO.hasOwnProperty(dictItemArray) && tmpEO[dictItemArray] != null) {
                        tmpEO[dictItemArray].push(selected[selected.length - 1].item);
                    } else {
                        tmpEO[dictItemArray] = [selected[selected.length - 1].item];
                    }
                } else {
                    //should never happen
                    //console.log("see, it happens !!!", selected);
                    selectedId = selected.item["_id"];
                    selectedLabel = getSelectedDisplayAndCode([selected], configField.dictDisplayField || null, configField.dictDisplayFieldCode || null);
                }
                selectedIdStd = typeof selectedId == 'object' ? selectedId["$oid"] : selectedId;
                if(selectedIdStd === 'selectAll') {
                    let allSelected = getSelectAllSelected(configField.dict,configField.idField || null, configField.dictDisplayField || null, configField.dictDisplayFieldCode || null);
                    tmpEO[dictItemArray].splice(0, tmpEO[dictItemArray].length, ...allSelected[1]) ;
                    if(configField.hasOwnProperty("divided")) {
                        tmpEO[configField.id+"_array_"+configField.divided.name].splice(0, tmpEO[configField.id+"_array_"+configField.divided.name].length, ...allSelected[0]);
                        tmpEO[configField.id+"_arrayLabels_"+configField.divided.name].splice(0, tmpEO[configField.id+"_arrayLabels_"+configField.divided.name].length, ...allSelected[2]);
                    }
                    else {
                        tmpEO[configField.id].splice(0, tmpEO[configField.id].length, ...allSelected[0]);
                        tmpEO[configField.id + "_array"].splice(0, tmpEO[configField.id + "_array"].length, ...allSelected[2]);
                    }
                } else {
                    if(configField.hasOwnProperty("divided")) {
                        if(tmpEO[configField.id+"_array_"+configField.divided.name].indexOf(selectedIdStd) < 0) {
                            tmpEO[configField.id+"_array_"+configField.divided.name].push(selectedIdStd);
                            tmpEO[configField.id+"_arrayLabels_"+configField.divided.name].push(selectedLabel);
                        }
                    }
                    else {
                        if (tmpEO[configField.id].indexOf(selectedIdStd) < 0) {
                            tmpEO[configField.id].push(selectedIdStd);
                            tmpEO[configField.id + "_array"].push(selectedLabel);
                        }
                    }
                }
                break;
            }
            case "removeOption": {
                let dictOption;
                let dictItemId;
                let removed
                if(typeof details.option == "string") {
                    removed = details.option;
                    dictOption = _.find(additionalDicts[configField.dict], {'label': removed});
                } else {
                    if(details.option.hasOwnProperty('item')){
                        removed = details.option.label;
                        dictOption = details.option;
                    } else {
                        return
                    }
                }
                if(typeof dictOption.item[configField.idField ? configField.idField : "_id"] == "object") dictItemId = dictOption.item._id["$oid"]
                else dictItemId = dictOption.item[configField.idField ? configField.idField : "_id"];

                if(configField.hasOwnProperty("divided")) {
                    let index0 = tmpEO[configField.id+"_array_"+configField.divided.name].indexOf(dictItemId);
                    if (index0 > -1) {
                        tmpEO[configField.id+"_array_"+configField.divided.name].splice(index0, 1);
                    }
                    let index0Label = tmpEO[configField.id+"_arrayLabels_"+configField.divided.name].indexOf(removed);
                    if (index0Label > -1) {
                        tmpEO[configField.id+"_arrayLabels_"+configField.divided.name].splice(index0Label, 1);
                    }
                } else {
                    let index = tmpEO[configField.id].indexOf(dictItemId);
                    if (index > -1) {
                        tmpEO[configField.id].splice(index, 1);
                    }
                    let itemIndex =  _.findIndex(tmpEO[dictItemArray], item => { return item[configField.idField] == dictItemId; });
                    if(itemIndex > -1){
                        tmpEO[dictItemArray].splice(itemIndex, 1);
                    }
                    let itemIndex2 = tmpEO[configField.id + "_array"].indexOf(removed);
                    if (itemIndex2 > -1) {
                        tmpEO[configField.id + "_array"].splice(itemIndex2, 1);
                    }
                }
            }
        }
        setEditObject(tmpEO);
    }

    const buildEditControl = (itemFieldConfig) => {
        let isReadOnly = itemFieldConfig.readOnly ? itemFieldConfig.readOnly : false;
        switch(itemFieldConfig.type){
            case "text":
                let inputProps = {};
                if(itemFieldConfig.maxlength) {
                    inputProps = {maxLength: itemFieldConfig.maxlength}
                }
                let value = "";
                const editObjectFieldValue = _.get(editObject, itemFieldConfig.id);
                if(editObjectFieldValue != null && typeof editObjectFieldValue == 'object'){
                    if(itemFieldConfig.id == props.idField && editObjectFieldValue.hasOwnProperty('$oid')) {
                        value = editObjectFieldValue['$oid'];
                    } else {
                        if(editObjectFieldValue.hasOwnProperty('$numberInt')){
                            value = editObjectFieldValue['$numberInt'].toString();
                        } else {
                            if(editObjectFieldValue.hasOwnProperty('$numberDouble')){
                                value = editObjectFieldValue['$numberDouble'].toString();
                            } else {
                                value = editObjectFieldValue.toString();
                            }
                        }
                    }
                } else {
                    try {
                        value = editObjectFieldValue.toString();
                    } catch(ex) {
                        value = "";
                    }
                }
                return(
                    <TextField
                        id={_.uniqueId("edit_")}
                        sx={{ m: 1, width: '100%' }}
                        variant="outlined"
                        value={value}
                        onChange={(event) => {
                            setEditObject(prevState => {
                                let tmp = {...prevState};
                                _.set(tmp, itemFieldConfig.id, event.target.value);
                                return tmp;
                            })
                        }}
                        label={(itemFieldConfig.id == props.idField && typeof editObject[itemFieldConfig.id] == 'object') ?  itemFieldConfig.display + "  : $oid" : itemFieldConfig.display}
                        disabled={(props.record[itemFieldConfig.id] != null && (itemFieldConfig.id == props.idField && !itemFieldConfig?.editableId)) || isReadOnly}
                        inputProps={inputProps}
                    />
                )
            case "number":
                return(
                    <TextField
                        id={_.uniqueId("edit_")}
                        sx={{ m: 1, width: '100%' }}
                        variant="outlined"
                        type="number"
                        value={editObject[itemFieldConfig.id.replace(".","___")+"_number"]}
                        onChange={(event) => {
                            setEditObject(prevState => {
                                let tmp = {...prevState};
                                tmp[itemFieldConfig.id.replace(".","___")+"_number"] = event.target.value;
                                return tmp;
                            })
                        }}
                        disabled={isReadOnly}
                        label={itemFieldConfig.display}
                    />
                )
            case "date":
                return (
                    <DatePicker
                        label={itemFieldConfig.display}
                        inputFormat={itemFieldConfig.format ? itemFieldConfig.format : defDateFormat}
                        inputVariant="outlined"
                        clearable={true}
                        ampm={false}
                        value={editObject[itemFieldConfig.id.replace(".","___")+"_date"]}
                        onChange={(value) => {
                            setEditObject(prevState => {
                                let tmp = {...prevState};
                                tmp[itemFieldConfig.id.replace(".","___")+"_date"] = value;
                                return tmp;
                            })
                        }}
                        onError={(e,v) => console.log("DatePicker onError", e, v, itemFieldConfig.id, editObject[itemFieldConfig.id.replace(".","___")+"_date"], editObject)}
                        disabled={isReadOnly}
                        renderInput={(inp) => <TextField style={{width: "100%", margin: "8px"}} {...inp}
                                                         size={props.size}/>}
                    />
                )
            case "boolean":
                return(
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography sx={{ paddingLeft: "10px"}}>{itemFieldConfig.display}</Typography>
                        <Switch
                            checked={_.get(editObject, itemFieldConfig.id)}
                            onChange={(event) => {
                                setEditObject(prevState => {
                                    let tmp = {...prevState};
                                    _.set(tmp, itemFieldConfig.id, event.target.checked);
                                    return tmp;
                                })
                            }}
                            disabled={isReadOnly}
                            inputProps={{ 'aria-label': 'controlled' }}
                        />
                    </Stack>
                )
            case "address":
                return(
                    <FormGroup>
                        <Typography>{itemFieldConfig.display}</Typography>
                        <TextField
                            id={_.uniqueId("edit_address_type")}
                            sx={{ m: 1, width: '30ch' }}
                            variant="outlined"
                            value={_.get(editObject, itemFieldConfig.id)?.type}
                            onChange={(event) => {
                                setEditObject(prevState => {
                                    let tmp = {...prevState};
                                    _.set(tmp, itemFieldConfig.id, event.target.value);
                                    return tmp;
                                })
                            }}
                            disabled={isReadOnly}
                            label={t("Address type")}
                        />
                        <TextField
                            id={_.uniqueId("edit_address_postal")}
                            sx={{ m: 1, width: '30ch' }}
                            variant="outlined"
                            value={editObject[itemFieldConfig.id]?.postalCode}
                            onChange={(event) => {
                                setEditObject(prevState => {
                                    let tmp = {...prevState};
                                    tmp[itemFieldConfig.id] = event.target.value;
                                    return tmp;
                                })
                            }}
                            disabled={isReadOnly}
                            label={t("Postal")}
                        />
                        {[0,1,2,3,4,5].map((idx)=> {
                            return (
                                <TextField
                                    id={_.uniqueId("edit_address_lines")}
                                    key={idx}
                                    sx={{ m: 1, width: '100%' }}
                                    variant="outlined"
                                    value={editObject[itemFieldConfig.id]?.lines[idx]}
                                    onChange={(event) => {
                                        setEditObject(prevState => {
                                            let tmp = {...prevState};
                                            tmp[itemFieldConfig.id] = event.target.value;
                                            return tmp;
                                        })
                                    }}
                                    disabled={isReadOnly}
                                    label={t("Address line") + " " + idx }
                                />
                            )
                        })}
                    </FormGroup>
                )
            case "dictionary":
            case "search":
                if(itemFieldConfig.dict){
                    let errorShows = false;
                    let missingText;
                    const dictItemKey = itemFieldConfig.id + "_dict_item";
                    if(editObject[dictItemKey] != null && (typeof editObject[dictItemKey]) != "object") {
                        missingText = t("An item");
                        missingText += " [" + editObject[itemFieldConfig.id] + "] ";
                        missingText += t("does not exits in the");
                        missingText += " [" + itemFieldConfig.dict + "] ";
                        missingText += t("dictionary") + ".";
                        errorShows = true;
                    }
                    return (
                        <React.Fragment>
                        <Autocomplete
                            id={"combo-box-dicts-to-edit-" + itemFieldConfig.dict}
                            options={additionalDicts[itemFieldConfig.dict]}
                            sx={{ m: 1, width: '100%' }}
                            renderInput={(params) => <TextField {...params} label={t("Select ") + itemFieldConfig.display} />}
                            value={editObject[dictItemKey]}
                            disabled={isReadOnly}
                            onChange={(event, selected, reason) => setDictField(selected, reason, itemFieldConfig.id)}
                        />
                            {errorShows &&
                                <Tooltip title={missingText}>
                                    <Box sx={{
                                        display: 'inline-flex',
                                        flexWrap: 'nowrap',
                                        justifyContent: 'flex-start'}}
                                         className={classes.dictRepresentationMissing}>
                                        <Box sx={{
                                            width: "24px",
                                            height: "24px",
                                            paddingLeft: "6px"
                                        }}>
                                            <WarningAmberIcon/>
                                        </Box>
                                        <Box sx={{
                                            paddingLeft: "12px"
                                        }}>
                                            {t("No item found in directory")}.
                                        </Box>
                                    </Box>
                                </Tooltip>
                            }
                        </React.Fragment>)
                }
                break;
            case "stringList":
                //lista z chipami
                return (
                    <FormGroup sx={{margin: "8px", width: "100%"}}>
                        <Typography className={classes.listHeader}>{itemFieldConfig.display}</Typography>
                        <Paper className={classes.tagsList}
                            sx={{display: 'flex', justifyContent: 'flex-start',
                                flexWrap: 'wrap', listStyle: 'none', p: 0.5, m: 0,
                            }}
                            component="ul"
                        >
                        {_.get(editObject, itemFieldConfig.id)?.map((stringItem) => {
                            return (<ListItem key={stringItem} sx={{width: "unset"}}>
                                <Chip
                                    label={stringItem}
                                    onDelete={() => {handleDeleteStringListItem(itemFieldConfig.id, stringItem)}}
                                />
                            </ListItem>)
                        })}
                            {addingNewStringChipField==null &&
                            <ListItem key="new-item-add" sx={{width: "unset"}}>
                                <IconButton aria-label="add-element" color="secondary" onClick={() => {
                                    addingNewChip(itemFieldConfig.id)
                                }}>
                                    <AddBoxIcon/>
                                </IconButton>
                            </ListItem>
                            }
                            {addingNewStringChipField==itemFieldConfig.id &&
                            <ListItem key="new-item-add" sx={{width: "unset"}}>
                                <FormControl fullWidth sx={{ m: 1 }}>
                                    <OutlinedInput
                                        className={classes.newTagItem}
                                        id={_.uniqueId("edit_new-item-add_")}
                                        variant="outlined"
                                        value={addingNewStringChip}
                                        onChange={(value) => {
                                            setAddingNewStringChip(value.target.value);
                                        }}
                                        endAdornment={<InputAdornment position="end">
                                            <IconButton sx={{ p: '10px', color: "#FF6868" }} aria-label="cancel" onClick={cancelAddingNewChip}>
                                                <CancelIcon />
                                            </IconButton>
                                            <IconButton sx={{ p: '10px', color: "#2BC12B" }} aria-label="save" onClick={saveAddingNewTextChip} disabled={addingNewStringChip.length<1}>
                                                <AddCircleIcon />
                                            </IconButton>
                                        </InputAdornment>}
                                    />
                                </FormControl>
                            </ListItem>
                            }
                        </Paper>
                    </FormGroup>)
            case "numberList":
                //lista z chipami
                return (
                    <FormGroup sx={{margin: "8px", width: "100%"}}>
                        <Typography className={classes.listHeader}>{itemFieldConfig.display}</Typography>
                        <Paper className={classes.tagsList}
                               sx={{display: 'flex', justifyContent: 'flex-start',
                                   flexWrap: 'wrap', listStyle: 'none', p: 0.5, m: 0,
                               }}
                               component="ul"
                        >
                            {editObject[itemFieldConfig.id]?.map((stringItem, index) => {
                                return (<ListItem key={_.uniqueId('numberList') + "-" + index} sx={{width: "unset"}}>
                                    <Chip
                                        label={stringItem["$numberInt"]}
                                        onDelete={() => {handleDeleteObjListItem(itemFieldConfig.id, stringItem)}}
                                    />
                                </ListItem>)
                            })}
                            {addingNewStringChipField==null &&
                            <ListItem key="new-item-add" sx={{width: "unset"}}>
                                <IconButton aria-label="add-element" color="secondary" onClick={() => {
                                    addingNewChip(itemFieldConfig.id)
                                }}>
                                    <AddBoxIcon/>
                                </IconButton>
                            </ListItem>
                            }
                            {addingNewStringChipField==itemFieldConfig.id &&
                            <ListItem key="new-item-add" sx={{width: "unset"}}>
                                <FormControl fullWidth sx={{ m: 1 }}>
                                    <OutlinedInput
                                        inputProps={{type:'number'}}
                                        className={classes.newTagItem}
                                        id={_.uniqueId("edit_new-item-add_")}
                                        variant="outlined"
                                        value={addingNewNumberChip}
                                        onChange={(value) => {
                                            setAddingNewNumberChip(value.target.value);
                                        }}
                                        endAdornment={<InputAdornment position="end">
                                            <IconButton sx={{ p: '10px', color: "#FF6868" }} aria-label="cancel" onClick={cancelAddingNewChip}>
                                                <CancelIcon />
                                            </IconButton>
                                            <IconButton sx={{ p: '10px', color: "#2BC12B" }} aria-label="save" onClick={saveAddingNewNumberChip} disabled={addingNewNumberChip.length<1}>
                                                <AddCircleIcon />
                                            </IconButton>
                                        </InputAdornment>}
                                    />
                                </FormControl>
                            </ListItem>
                            }
                        </Paper>
                    </FormGroup>)
            case "objectList":
                //lista z chipami
                return (
                    <FormGroup sx={{margin: "8px", width: "100%"}}>
                        <Typography className={classes.listHeader}>{itemFieldConfig.display}</Typography>
                        <Paper className={classes.tagsList}
                               sx={{display: 'flex', justifyContent: 'flex-start',
                                   flexWrap: 'wrap', listStyle: 'none', p: 0.5, m: 0,
                               }}
                               component="ul"
                        >
                            {editObject[itemFieldConfig.id]?.map((objectItem, index) => {
                                return (<ListItem key={_.uniqueId('objectList') + "-" + index} sx={{width: "unset"}}>
                                    {objectChip(objectItem, itemFieldConfig)}
                                </ListItem>)
                            })}
                            {addingNewStringChipField==null &&
                            <ListItem key="new-item-add" sx={{width: "unset"}}>
                                <IconButton aria-label="add-element" color="secondary" onClick={() => {
                                    addingNewChip(itemFieldConfig.id, itemFieldConfig.fields)
                                }}>
                                    <AddBoxIcon/>
                                </IconButton>
                            </ListItem>
                            }
                            {addingNewStringChipField==itemFieldConfig.id &&
                            <ListItem key="new-item-add" sx={{width: "unset"}}>
                                <FormControl fullWidth sx={{ m: 1 }} className={classes.tagListObjectAdd}>
                                    <div>
                                        {itemFieldConfig.fields && Object.keys(itemFieldConfig.fields).map((subfieldsName) => {
                                            const txFieldId = _.uniqueId("subfield_textInput_" + subfieldsName);
                                            let inputPropsObj = {type: "text"};
                                            if(itemFieldConfig.fields[subfieldsName].startsWith("$number")){
                                                inputPropsObj['type'] = "number";
                                                inputPropsObj['inputMode'] = 'numeric';
                                                inputPropsObj['pattern'] = '[0-9]*';
                                            }
                                            if(itemFieldConfig.fields[subfieldsName].endsWith("Double")){
                                                inputPropsObj['step'] = 0.1;
                                            }
                                            return (
                                                <TextField
                                                    error={addingNewObjectChip[subfieldsName] == null || addingNewObjectChip[subfieldsName].length == 0}
                                                    className={classes.tagListObjectInput}
                                                    size="small"
                                                    required
                                                    id={txFieldId}
                                                    label={subfieldsName}
                                                    inputProps={inputPropsObj}
                                                    value={addingNewObjectChip[subfieldsName]}
                                                    onChange={(event) => {
                                                        let tmpObj = _.cloneDeep(addingNewObjectChip);
                                                        tmpObj[subfieldsName] = event.target.value;
                                                        addingNewObjectChipValidation(tmpObj);
                                                    }}
                                                />
                                            )
                                            })
                                        }
                                    </div>
                                    <div className={classes.tagListButton}>
                                        <IconButton sx={{ p: '10px', color: "#FF6868" }} aria-label="cancel" onClick={cancelAddingNewChip}>
                                            <CancelIcon />
                                        </IconButton>
                                        <IconButton sx={{ p: '10px', color: "#2BC12B" }} aria-label="save" onClick={() => saveAddingNewObjectChip(itemFieldConfig.fields)} disabled={!addingNewObjectChip.valid}>
                                            <AddCircleIcon />
                                        </IconButton>
                                    </div>
                                </FormControl>
                            </ListItem>
                            }
                        </Paper>
                    </FormGroup>)
            case "color":
                return(
                    <div className={classes.inputColorPickerContainer}>
                        <fieldset>
                            <legend className={classes.inputColorPickerLegend}>{itemFieldConfig.display}</legend>
                            <input id={_.uniqueId("edit_color_text_")}
                                   className={classes.inputColorPickerText}
                                   type="text"
                                   value={editObject[itemFieldConfig.id]}
                                   onChange={(event) => {
                                       setEditObject(prevState => {
                                           let tmp = {...prevState};
                                           tmp[itemFieldConfig.id] = event.target.value;
                                           return tmp;
                                       })
                                   }}
                                   disabled={isReadOnly}
                            />
                            <input id={_.uniqueId("edit_color_")}
                                   className={classes.inputColorPickerColor}
                                   type="color"
                                   value={editObject[itemFieldConfig.id]}
                                   onChange={(event) => {
                                       setEditObject(prevState => {
                                           let tmp = {...prevState};
                                           tmp[itemFieldConfig.id] = event.target.value;
                                           return tmp;
                                       })
                                   }}
                                   disabled={isReadOnly}
                            />
                        </fieldset>
                    </div>
                )
            case "searchList":
                const dictItemKey = itemFieldConfig.id + "_array";
                return (
                    <React.Fragment>
                        <Autocomplete
                            id={"combo-box-dicts-to-edit-" + itemFieldConfig.dict}
                            multiple={itemFieldConfig.singleOption ? !itemFieldConfig.singleOption : true}
                            options={additionalDicts[itemFieldConfig.dict]}
                            sx={{ m: 1, width: '100%' }}
                            renderInput={(params) => <TextField {...params} label={t("Select ") + itemFieldConfig.display} />}
                            value={editObject[dictItemKey]}
                            disabled={isReadOnly}
                            onChange={(event, selected, reason, details) => setDictFieldAddToArray(selected, reason, itemFieldConfig, details)}
                        />
                    </React.Fragment>
                )
            case "dividedSearchList": {
                const dictItemKey = itemFieldConfig.id + "_arrayLabels_" + itemFieldConfig.divided.name;
                return (
                    <React.Fragment>
                        <Autocomplete
                            id={"combo-box-dicts-to-edit-" + itemFieldConfig.dict}
                            multiple={itemFieldConfig.singleOption ? !itemFieldConfig.singleOption : true}
                            options={additionalDicts[itemFieldConfig.dict]}
                            sx={{ m: 1, width: '100%' }}
                            renderInput={(params) => <TextField {...params} label={t("Select ") + itemFieldConfig.divided?.prefix + " " + itemFieldConfig.display  } />}
                            value={editObject[dictItemKey]}
                            disabled={isReadOnly}
                            onChange={(event, selected, reason, details) => setDictFieldAddToArray(selected, reason, itemFieldConfig, details)}
                        />
                    </React.Fragment>
                )
            }
            case "colorListSelect": {
                const options = props.config?.additionalFunctions || [];

                const handleChange = (event) => {
                    setEditObject(prevState => {
                        let tmp = {...prevState};
                        tmp[itemFieldConfig.id] = event.target.value;
                        return tmp;
                    })
                };

                return (
                    <Box sx={{margin: 1}}>
                        <FormControl fullWidth>
                            <InputLabel>
                                {t('Select colour')}
                            </InputLabel>

                            <Select
                                value={editObject[itemFieldConfig.id] || ''}
                                onChange={handleChange}
                                label={t('Select colour')}
                            >
                                {options.map((color) => (
                                    <MenuItem key={color} value={color}>
                                        <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                                            <Box
                                                sx={{
                                                    width: 20,
                                                    height: 20,
                                                    backgroundColor: color,
                                                    borderRadius: '50%',
                                                }}
                                            />
                                            {color}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                );
            }
            case "dictionaryList":
            default:
                if(itemFieldConfig.type) {
                    return (
                        <div>
                            {t("Unsupported field type: ")} {itemFieldConfig.type}
                        </div>
                    )
                } else {
                    return (
                        <div>
                            {t("Missing field type")}
                        </div>
                    )
                }
        }
    }

    const handleDeleteStringListItem = (fieldId, stringItem) => {
        let tmpObj = _.cloneDeep(editObject);
        let itemArr = _.get(tmpObj, fieldId);
        itemArr.splice(itemArr.indexOf(stringItem),1);
        _.set(tmpObj, fieldId, itemArr);
        setEditObject(tmpObj);
    }

    const handleDeleteObjListItem = (fieldId, objItem) => {
        let tmpObj = _.cloneDeep(editObject);
        let itemArr = _.get(tmpObj, fieldId);
        _.remove(itemArr, item => {
            return JSON.stringify(item) == JSON.stringify(objItem);
        })
        _.set(tmpObj, fieldId, itemArr);
        setEditObject(tmpObj);
    }

    const handleAddStringListItem = (fieldId, stringItem) => {
        let tmp = [];
        if(editObject[fieldId] != null && Array.isArray(editObject[fieldId]) && editObject[fieldId].length > 0){
            tmp = [...editObject[fieldId]];
        }
        tmp.push(stringItem);
        let tmpObj = _.cloneDeep(editObject);
        tmpObj[fieldId] = tmp;
        setEditObject(tmpObj);
    }

    const objectChip = (objectItem, configField) => {
        let newItemEl = {};
        Object.keys(configField['fields']).forEach( key => {
            if(typeof objectItem[key] == "object"){
                Object.keys(objectItem[key]).forEach( nestedKey => {
                    switch(nestedKey){
                        case "$numberInt":
                        case "$numberDouble" :
                        case "$numberLong" :
                        case "$oid":{
                            newItemEl[key] = objectItem[key][nestedKey];
                            break;
                        }
                        default: {
                            console.error("unrecognized key type " + nestedKey);
                            newItemEl[key] = JSON.stringify(objectItem[nestedKey]);
                        }
                    }
                });
            } else {
                newItemEl[key] = objectItem[key];
            }
        })
        let strValue = JSON.stringify(newItemEl).replaceAll(",", ", ").replaceAll('"', '');
        return (<Chip
            label={strValue}
            onDelete={() => {handleDeleteObjListItem(configField.id, objectItem)}}
        />)
    }

    const buildEditRows = (configForm) => {
        let itemRows = [];
        if(configForm) {
            configForm.map((itemField) => {
                itemRows.push(<Grid item xs={12} key={'control_' + itemField.id}>{buildEditControl(itemField)}</Grid>);
            });
        }
        return itemRows;
    }

    return (

        <React.Fragment>
            {props.record &&
            <React.Fragment>
                <DialogTitle>
                    {props.record[props.idField] != null ? t("Edit record") : t("Add record")}
                </DialogTitle>
                <DialogContent>
                <Grid container>
                    {buildEditRows(configFormFields)}
                </Grid>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCancel}>
                    {t("Cancel")}
                </Button>
                <Button onClick={handleSave} disabled={addingNewStringChipField != null}>
                    {props.record[props.idField ] != null ? t("Save") : t("Add")}
                </Button>
                </DialogActions>
            </React.Fragment>
            }
        </React.Fragment>
    )
}